<template>
    <div id="app">
        <!--        <LoadingBar v-if="!isMac"/>-->
        <div class="content">
            <Header v-if="$device.isDesktop" />
            <HeaderMobile v-else />
            <!--            <NotifyVPN></NotifyVPN>-->
            <div class="sub-header" v-if="showCrumbs">
                <div class="container">
                    <breadcrumbs />
                </div>
            </div>
            <nuxt />
        </div>
        <Footer v-if="$device.isDesktop" />
        <FooterMobile v-else />
        <!--        <SubscribePopup />-->
        <NotifyModal />
        <SupportWidget />
        <SubscribePopup2 v-if="$route.name !== 'lk-register'" />
        <CookiesModal />
        <QrCodeModal v-if="QRCodeModal" />
        <!--        <CountryModal/>-->
    </div>
</template>
<script>
// @ is an alias to /src
// import LoadingBar from "@/components/LoadingBar";
import Header from "@/components/Header.vue";
import HeaderMobile from "@/components/HeaderMobile.vue";
import Footer from "@/components/Footer.vue";
import FooterMobile from "@/components/FooterMobile.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
// import SubscribePopup from "@/components/SubscribePopup";
import NotifyModal from "@/components/NotifyModal.vue";
import SupportWidget from "../components/ui/SupportWidget.vue";
// import NotifyVPN from "../components/NotifyVPN.vue";
import SubscribePopup2 from "@/components/ui/SubscribePopup2.vue";
import CookiesModal from "@/components/ui/CookiesModal.vue";
// import CountryModal from "@/components/CountryModal.vue";
import QrCodeModal from "@/components/QrCodeModal.vue";
import { mapGetters } from "vuex";

export default {
    name: "App",

    components: {
        QrCodeModal,
        SubscribePopup2,
        SupportWidget,
        // NotifyVPN,
        // LoadingBar,
        Header,
        HeaderMobile,
        Footer,
        FooterMobile,
        Breadcrumbs,
        // SubscribePopup,
        NotifyModal,
        CookiesModal,
        // CountryModal,
    },
    data() {
        return {
            isMac: false,
        };
    },
    computed: {
        ...mapGetters({
            QRCodeModal: "order/getQRCodeModal",
        }),
        bodyClass() {
            let bodyClass = this.$device.isDesktop ? "is_desktop" : "is_mobile";
            bodyClass += this.isMac ? " is_apple" : "";
            bodyClass += " page-" + this.$route.name;
            bodyClass += this.showCrumbs ? "" : " no-subheader";
            return bodyClass;
        },
        showCrumbs() {
            return this.$device.isDesktop && this.$route.name !== "index";
        },
    },
    head() {
        return {
            link: [
                { hid: "my-canon-link", rel: "canonical", href: "https://post-post-scriptum.com" + this.$route.path },
            ],
            meta: [
                {
                    hid: "my-canon-meta",
                    rel: "canonical",
                    href: "https://post-post-scriptum.com" + this.$route.path,
                },
                {
                    hid: "description",
                    name: "description",
                    content:
                        "PPS предлагает большой выбор образов  для самовыражения. Мы создаём одежду, которая не мешает быть собой и оставляет место для твоего собственного высказывания. Наш телефон в Москве: +7 (499) 229-11-11",
                },
                {
                    hid: "og:description",
                    property: "og:description",
                    content:
                        "PPS предлагает большой выбор образов  для самовыражения. Мы создаём одежду, которая не мешает быть собой и оставляет место для твоего собственного высказывания. Наш телефон в Москве: +7 (499) 229-11-11",
                },
            ],
            bodyAttrs: {
                class: this.bodyClass,
            },
        };
    },
    watch: {
        $device() {
            if (this.$device.isIos || this.$device.isMacOS) this.isMac = true;
        },
    },
    mounted() {
        this.isMac = this.$device.isIos || this.$device.isMacOS;
    },
};
</script>
